import { IAssetCategoryTypeResponse } from '@kcftech/prometheustypescriptapiclient';
import { DataSourceTable } from 'components/data_source_table/DataSourceTable';
import { TableColumn } from 'components/data_table/types';
import { ArrowLink } from 'components/link/ArrowLink';
import { AssetCategoryTypePagedDataSource } from 'custom_hooks/data_hooks/data_source/assetCategoryTypeDataSource';
import { AssetTypeNameInlineEditor } from 'pages/Settings/AssetType/table_cells/AssetTypeNameInlineEditor';
import { AssetTypeStatusInlineEditor } from 'pages/Settings/AssetType/table_cells/AssetTypeStatusInlineEditor';
import { FullWidthWrapper } from 'pages/Settings/shared/styled';
import { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { DebugValue } from 'shared/debug/DebugValue';
import { getId } from 'utils/data';
import { appendToRoute } from 'utils/RouteHelper';

export type AssetTypesTableProps = Readonly<{
    className?: string;
    dataSource: AssetCategoryTypePagedDataSource;
}>;

export function AssetTypesTable({ dataSource, className }: AssetTypesTableProps) {
    const { url } = useRouteMatch();
    const { reloadPage } = dataSource;

    const columns = useMemo<TableColumn<IAssetCategoryTypeResponse>[]>(
        () => [
            {
                header: () => 'Name',
                id: 'Name',
                value: ({ rowData }) => (
                    <ArrowLink
                        aria-label={`${rowData.Name} asset type name arrow link`}
                        title="Select asset type"
                        to={appendToRoute(url, rowData.Id)}
                    >
                        <FullWidthWrapper className="flex-row">
                            <DebugValue value={rowData} description="Asset Type" />
                            <AssetTypeNameInlineEditor
                                assetType={rowData}
                                onUpdate={reloadPage}
                            />
                        </FullWidthWrapper>
                    </ArrowLink>
                ),
                sortOn: 'Name',
                primary: true,
                locked: true,
            },
            {
                header: () => 'Code',
                id: 'Code',
                value: ({ rowData }) => <div className="text-nowrap">{rowData.Code}</div>,
                sortOn: 'Code',
                locked: true,
            },
            {
                header: () => 'Status',
                id: 'Status',
                value: ({ rowData }) => (
                    <div className="text-nowrap">
                        <AssetTypeStatusInlineEditor
                            assetType={rowData}
                            onUpdate={reloadPage}
                        />
                    </div>
                ),
                locked: true,
            },
        ],
        [reloadPage, url]
    );

    return (
        <DataSourceTable
            dataSource={dataSource}
            rowKey={getId}
            columns={columns}
            noResultMessage="No asset types found"
            tableClassName={className}
        />
    );
}
